var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 0c8.832 0 16 7.168 16 16s-7.168 16-16 16S0 24.832 0 16 7.168 0 16 0zm0 29.344c7.36 0 13.344-5.984 13.344-13.344S23.36 2.656 16 2.656C8.64 2.656 2.656 8.64 2.656 16S8.64 29.344 16 29.344zm-4.768-11.808l3.424 2.304V9.344C14.656 8.608 15.264 8 16 8s1.344.608 1.344 1.344V19.84l3.424-2.304c.288-.192.672-.256.992-.16.352.128.608.384.736.704.352.704.16 1.536-.448 2.016l-5.024 3.392s-.032.032-.064.032a.908.908 0 01-.32.288.967.967 0 01-.512.16h-.064c-.032 0-.032.032-.064.032s-.032-.032-.064-.032h-.096c-.096 0-.224-.032-.32-.064-.064-.032-.096-.064-.16-.096s-.16-.096-.224-.16c-.064-.032-.096-.096-.128-.16l-5.056-3.392a1.671 1.671 0 01-.448-2.048c.128-.32.384-.544.736-.672.32-.096.704-.032.992.16z"
  })));
}

export default SvgDownload;